"use strict";

function makeRequest(url, requestType, data, processingEl, fnDone, fnOnError) {
  if (!url) {
    return;
  } // encode optional data to url

  if (data && data.length) {
    url = buildUrl(url, data);
  } // set processing css class (either generic window or button)

  var processingCssClass = "loading";
  if (processingEl && processingEl.classList.contains("btn")) {
    processingCssClass = "btn__loading";
  }
  var isModal = processingEl && processingEl.classList.contains("modal");
  var xhttp = new XMLHttpRequest(); // function to be executed when the readyState changes

  xhttp.onreadystatechange = function () {
    var isProcessing = true;
    if (this.readyState === 4) {
      // done
      isProcessing = false;
    } // start progress animation logic if element is passed through

    if (processingEl) {
      if (isProcessing) {
        processingEl.classList.add(processingCssClass);
        if (isModal) {
          $(processingEl).modal('show');
        }
      } else {
        processingEl.classList.remove(processingCssClass);
        if (isModal) {
          $(processingEl).modal('hide');
        }
      }
    }
  };
  xhttp.onload = function () {
    var isNetworkSuccess = true;
    if (xhttp.status < 200 || xhttp.status >= 400) {
      isNetworkSuccess = false;
      console.log("Error on " + url);
    }
    if (fnDone) {
      fnDone(xhttp, isNetworkSuccess);
    }
  };
  xhttp.onerror = function () {
    console.log("Connection error on " + url);
    if (fnOnError) {
      fnOnError(xhttp);
    }
  };
  xhttp.open(requestType, url, true);
  xhttp.send();
}
function buildUrl(url, fields) {
  if (!fields || fields.length < 1) {
    return url;
  }
  for (var i = 0; i < fields.length; i++) {
    if (!fields[i] || !fields[i].key || !fields[i].value) {
      continue;
    }
    url += i === 0 ? "?" : "&";
    url += fields[i].key + "=" + encodeURIComponent(fields[i].value);
  }
  return url;
}